import React, { createRef, useEffect, useState } from "react";
import './expoLotReport.css';
import CustomSearchBar from "../../../components/CustomSearchBar/CustomSearchBar";
import Table from "../../../components/Table/Table";
import api from "../../../api/api";
import apiUtil from "../../../api/apiUtil";
import getToken, { redirectToLogin } from "../../getToken";
import authStore from "../../../store/authStore";
import { DateRange } from "react-date-range";
import { format, parseISO } from "date-fns";
import calenderIcon from "../../../images/icons/calendar.png";
import * as XLSX from "xlsx";
import excelIcon from "../../../images/icons/download.png";
import { message } from "antd";

const ExpoLotReport = () => {
    const refExpoLotReportTable = createRef();
    const [keyword, setKeyword] = useState();
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const [showDatePicker, setShowDatePicker] = useState(false);
    const [excelData, setExcelData] = useState([]);
    const [dateRange, setDateRange] = useState({
        startDate: new Date(),
        endDate: new Date()
    });
    const brandId = authStore((state) => state.auth?.brandId);

    const [reportList, setReportList] = useState({
        isLoading: true,
        grouping: false,
        limit: apiUtil.getDefaultPageSize(),
        data: [],
        total: 0,
        page: 1,
    });

    const [paramReport, setParamReport] = useState({
        keyword: "",
        rowLimit: 10,
        currentPage: 1,
        sortBy: "",
        isDesc: true,
        brandId: brandId,
        startDate: format(startDate, "yyyy-MM-dd"),
        endDate: format(endDate, "yyyy-MM-dd"),
    });


    const retrieveReportList = async (value = paramReport) => {
        var request = {
            ...value,
            keyword: value.keyword || "",
            startDate: format(startDate, "yyyy-MM-dd"),
            endDate: format(endDate, "yyyy-MM-dd")
        };

        api
            .post("Admin/GetExpoLotReport", request, getToken())
            .then((result) => {
                apiUtil.parseResult(
                    result,
                    (response) => {
                        const data = response.data.data;
                        if (response.data.code === 401) {
                            message.warning(response.data.message);
                            redirectToLogin();
                        } else if (response.data.code === 200) {
                            setReportList({
                                isLoading: false,
                                limit: 10,
                                data: response.data.data.data || [],
                                total: response.data.data.totalRecords,
                                page: response.data.data.paging,
                            });
                            setExcelData(response.data.data.data);
                        } else {
                            setReportList({
                                data: [],
                                total: 0,
                                page: 0,
                                limit: 0,
                                isLoading: false,
                            });
                        }
                    },
                    (error, type) => {
                        console.log(error);
                    }
                );
            });
    };

    const exportToExcel = async () => {
        try {
            const request = {
                ...paramReport,
                keyword,
                currentPage: 1,
                rowLimit: 100000,
                startDate: format(startDate, "yyyy-MM-dd"),
                endDate: format(endDate, "yyyy-MM-dd"),
            };
            const result = await api.post("Admin/GetExpoLotReport", request, getToken());
            apiUtil.parseResult(result, (response) => {
                const data = result.data.data.data || [];
                const excelDataFormatted = data.map((row, index) => ({
                    No: index + 1,
                    Expo: row.expoName,
                    Lot: row.lotName,
                    Service: row.serviceName,
                    Marker: row.markerName,
                    Quantity: row.quantity,
                    Weight: row.weight,
                    "Reserve Price": row.reservePrice,
                    Sale: row.saleAmount,
                }));

                const fileName = "ပြပွဲ အရောင်းစာရင်း.xlsx";
                const ws = XLSX.utils.json_to_sheet(excelDataFormatted);
                const wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, ws, "ပြပွဲ အရောင်းစာရင်း");
                XLSX.writeFile(wb, fileName);
            });
        } catch (error) {
            console.error("Error exporting to Excel:", error);
        }
    };

    useEffect(() => {
        retrieveReportList({
            ...paramReport,
            keyword
        });
    }, [paramReport.currentPage, startDate, endDate]);

    const handleDateRangeChange = (ranges) => {
        const { startDate, endDate } = ranges.selection;
        setStartDate(startDate);
        setEndDate(endDate);
        setDateRange({ startDate, endDate });
        retrieveReportList();
    };

    const handleInputClick = () => {
        setShowDatePicker((prevState) => !prevState);
    };

    useEffect(() => {
        const handleOutsideClick = (e) => {
            if (!e.target.closest(".date-input-container")) {
                setShowDatePicker(false);
            }
        };

        document.addEventListener("click", handleOutsideClick);
        return () => {
            document.removeEventListener("click", handleOutsideClick);
        };
    }, []);

    return (
        <>
            <div className="Actions space_between">
                <h6 className="title_text mt-2">Expo Lot Report</h6>

                <div className="d-flex justify-content-end gap-16 align-items-center">
                    <div>
                        <button className="export-button" onClick={exportToExcel}>
                            <img src={excelIcon} className="icon" />
                            Export to Excel
                        </button>
                    </div>

                    <div className="date-input-container ">
                        <input
                            type="text"
                            className="inputBox input-right-side_text "
                            value={`${format(dateRange.startDate, "yyyy MMM dd")} - ${format(
                                dateRange.endDate,
                                "yyyy MMM dd"
                            )}`}
                            readOnly
                            onClick={handleInputClick}
                        />
                        <img
                            src={calenderIcon}
                            className="iconDate"
                            onClick={handleInputClick}
                        />
                        {showDatePicker && (
                            <div className="input-dateRange">
                                <DateRange
                                    showDateDisplay={false}
                                    ranges={[{ startDate, endDate, key: "selection" }]}
                                    onChange={handleDateRangeChange}
                                />
                            </div>
                        )}
                    </div>
                    <div>
                        <CustomSearchBar
                            value={keyword}
                            setValue={setKeyword}
                            onSearch={(value) => retrieveReportList({
                                ...paramReport,
                                keyword: value || "",
                                currentPage: 1
                            })}
                        />
                    </div>
                </div>
            </div>

            <div className="table_container report_table">
                <Table
                    ref={refExpoLotReportTable}
                    maxBodyHeight={reportList.limit * 100}
                    isLoading={reportList.isLoading}
                    grouping={reportList.grouping}
                    limit={reportList.limit}
                    page={reportList.page}
                    total={reportList.total}
                    data={reportList.data}
                    onPageChange={(page) => {
                        setParamReport({
                            ...paramReport,
                            currentPage: page,
                        });
                    }}
                    columns={[
                        {
                            title: "No",
                            render: (row) => row.tableIndex + 1,
                            width: "80px",
                        },
                        {
                            title: "Expo",
                            field: "expoName"
                        },
                        {
                            title: "Lot",
                            field: "lotName"
                        },
                        {
                            title: "Service",
                            field: "serviceName",
                        },
                        {
                            title: "Marker",
                            field: "markerName"
                        },
                        {
                            title: "Quantity",
                            field: "quantity"
                        },
                        {
                            title: "Weight",
                            field: "weight"
                        },
                        {
                            title: "Reserve Price",
                            render: (row) => {
                                return Number(row.reservePrice).toLocaleString();
                            }
                        },
                        {
                            title: "Sale Amount",
                            render: (row) => {
                                return Number(row.saleAmount) == 0 ? "-" : Number(row.saleAmount).toLocaleString();
                            }
                        },
                    ]}
                />
            </div>
        </>
    );
}
export default ExpoLotReport;